import type { SVGProps } from 'react';
import { AnimalFace } from './AnimalFace';

export function AnimalHyppo(props: SVGProps<SVGSVGElement>) {
  return (
    <AnimalFace size={150} {...props}>

  <>
    <path
      d="M33.855 80.98c19.269-7.996 45.119-7.483 68.324-1.625 8.787 2.22 6.744 1.594 12.525-4.314 4.962-5.076 13.263-5.795 18.284-2.244a43.123 43.123 0 00-.773-3.207c-4.504-15.793-9.54-36.286-23.304-46.82-15.935-12.204-52.905-15.993-68.666-2.177-16.02 14.049-22.566 38.53-25.093 52.079 7.902-3.62 15.555 1.588 18.703 8.309"
      fill="#ADC0C1"
    />
    <path
      d="M46.025 70.194c1.657-8.584-5.614-9.747-9.163-10.578-3.55-.83-8.006 1.84-8.904 6.615-.899 4.782 1.011 8.36 5.199 9.67 4.186 1.312 11.209 2.884 12.868-5.707zM119.258 66.298c-1.435-6.299-9.341-7.153-14.992-3.517-5.649 3.635-2.715 13.071 3.959 15.485 6.674 2.413 12.469-5.664 11.033-11.968"
      fill="#E195B6"
    />
    <path
      d="M50.776 54.193c.204-1.59-.188-3.515-1.146-4.8-.789-1.06-2.234-1.409-3.537-1.18-2.273.395-3.039 5.056-3.248 7.174-.212 2.112 1.057 5.471 4.004 5.64 2.948.167 3.546-3.87 3.927-6.834zM106.332 56.8c.694-2.192.443-4.743-1.916-6.3-.798-.528-1.94-1.05-2.989-.798-3.901.929-3.026 8.908-.268 10.585.633.39 1.67.186 2.38-.138 1.61-.725 2.387-2.06 2.793-3.348"
      fill="#1F1611"
    />
    <path
      d="M102.582 40.928c.649.28 1.293.571 1.928.875.308.152.61.31.91.473.229.128 1.082.79.396.207 1.059.905 2.576 1.044 3.62 0 .928-.93 1.06-2.715 0-3.62-1.246-1.068-2.777-1.712-4.271-2.35-1.281-.552-2.731-.395-3.501.917-.639 1.087-.364 2.952.918 3.498M39.215 36.87c-1.66.425-3.167 1.323-4.514 2.361-1.101.85-1.69 2.179-.917 3.502.637 1.087 2.394 1.773 3.5.917a17.393 17.393 0 011.772-1.208c.306-.182.626-.34.948-.486-.366.17.477-.127.572-.151 1.35-.346 2.152-1.821 1.787-3.15-.375-1.36-1.797-2.13-3.148-1.785"
      fill="#716478"
    />
    <path
      d="M28.644 34.816c3.172-5.264 6.992-10.18 11.603-14.225 1.422-1.244 3.02-2.338 4.754-3.305C40.302 7.107 25.034-4.218 15.404 6.039c-8.349 8.885 3.965 25.164 13.24 28.778"
      fill="#928397"
    />
    <path
      d="M30.852 31.371c2.495-3.657 5.347-7.063 8.598-10.05-4.1-6.172-11.612-17.984-19.781-12.3-7.96 5.532 3.245 19.408 11.183 22.35"
      fill="#DDA1C5"
    />
    <path
      d="M108.913 22.771c4.013 3.07 7.267 7.006 9.999 11.405 10.378-3.766 22.875-15.126 15.69-25.974-9.24-13.954-27.13.127-32.358 10.513 2.481 1.215 4.733 2.57 6.669 4.056"
      fill="#928397"
    />
    <path
      d="M108.912 22.767c2.617 2.009 4.915 4.37 6.957 6.995 7.165-2.744 20.053-10.92 15.867-18.286-5.208-9.168-19.445 1.915-25.725 9.312a36.553 36.553 0 012.901 1.979"
      fill="#DDA1C5"
    />
    <path
      d="M137.356 90.985c-.582-4.095.685-8.654-.593-12.954-2.614-8.79-15.374-9.83-22.058-2.997-5.781 5.91-3.737 6.533-12.525 4.319-23.205-5.864-49.056-6.369-68.325 1.627-3.305-7.062-11.576-12.473-19.888-7.72-6.641 3.795-5.64 12.937-2.671 20.063 1.615 3.878-9.151 30.28 12.262 44.574 13.906 9.283 33.872 10.658 49.767 10.658 18.91 0 49.221-3.279 61.457-19.905 11.577-15.733 3.304-32.524 2.574-37.665"
      fill="#B798AD"
    />
    <path
      d="M58.337 131.138c7.458 8.19 22.368 7.887 28.527-2.031.935-1.507-1.434-2.881-2.363-1.385-5.255 8.461-18 8.323-24.229 1.479-1.19-1.308-3.121.635-1.935 1.937"
      fill="#1F1611"
    />
    <path
      d="M120.372 79.72c-2.326 2.081-.86 5.734 1.287 7.096 2.607 1.648 6.86 4.22 9.643 2.22 2.784-1.992-3.596-15.891-10.93-9.316zM23.282 79.042c-7.545-1.134-9.135 10.48-6.737 12.318 2.398 1.832 9.053-4.193 10.093-5.6 2.391-3.234.672-6.113-3.356-6.718z"
      fill="#716478"
    />
    <path fill="#fff" fillOpacity={0} d="M149 0h1v1H0zM149 149h1v1h-1z" />
  </>
    </AnimalFace>
  );
}
